import React from 'react';
import { Modal } from 'antd';

/**
 * Componente per visualizzare un'immagine in una modale
 * 
 * @param {boolean} props.visible - Se la modale è visibile
 * @param {function} props.onClose - Funzione da chiamare quando la modale viene chiusa
 * @param {string} props.imageUrl - URL dell'immagine da visualizzare
 * @param {string} props.title - Titolo della modale
 */
const ImagePreviewModal = ({ visible, onClose, imageUrl, title }) => {
    return (
        <Modal
            open={visible}
            onCancel={onClose}
            footer={null}
            title={title || 'Image Preview'}
            centered
            width={800}
            style={{ padding: 0 }}
        >
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#f0f0f0',
                minHeight: '400px',
                maxHeight: '80vh',
                overflow: 'hidden'
            }}>
                <img
                    src={imageUrl}
                    alt="Preview"
                    style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain'
                    }}
                />
            </div>
        </Modal>
    );
};

export default ImagePreviewModal;
